import type { StateCreator } from 'zustand';
import type { FlowMedia } from '@/types';

import type { ResultSlice } from './types';

export type { ResultSlice } from './types';

export const resultInitialState = {
  resultFile: null as FlowMedia | null,
  generationTimestamp: null as number | null,
  pendingReadyCount: 0,
};

export const createResultSlice: StateCreator<
  ResultSlice,
  [],
  [],
  ResultSlice
> = (set) => ({
  ...resultInitialState,

  setResultFile: (resultFile) => set({ resultFile }),
  setGenerationTimestamp: (generationTimestamp) => set({ generationTimestamp }),
  incrementPendingReadyCount: (by = 1) =>
    set((state) => ({
      pendingReadyCount: state.pendingReadyCount + Math.max(1, by),
    })),
  resetPendingReadyCount: () => set({ pendingReadyCount: 0 }),
});
